import { Activity, ArrowUpRight, Loader2 } from 'lucide-react';
import React from 'react';
import { useDashboardContext } from './DashboardContext';
import { formatMoney } from './helpers';

export const NetSalesCard: React.FC = () => {
  const { dashboard, loadingStates } = useDashboardContext();
  return (
    <div className="relative flex flex-col justify-between overflow-hidden rounded-[22px] bg-[#111c14] p-5 text-white shadow-sm lg:col-span-2">
      <div className="relative z-10">
        <p className="flex items-center gap-2 text-[11px] text-emerald-100/70">
          Net Sales <Activity size={13} />
        </p>
        <div className="mt-1.5 text-[30px] font-bold text-white tracking-tight md:text-[36px] h-[48px] flex items-center">
          {loadingStates.summary ? (
            <Loader2 className="animate-spin text-emerald-400" size={32} />
          ) : (
            formatMoney(dashboard.summary.netSales)
          )}
        </div>
      </div>
      <div className="relative z-10 mt-6 flex items-center gap-2.5">
        <span className="flex items-center gap-1 rounded-md bg-emerald-500/20 px-2 py-0.5 text-[11px] font-semibold text-emerald-400">
          <ArrowUpRight size={13} /> Top Performer
        </span>
        <span className="text-[10px] text-emerald-100/50">
          vs other periods
        </span>
      </div>
      <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-emerald-500/10 blur-2xl" />
    </div>
  );
};
